import type { FaireProductEntity } from "../../entity_types/product";

export const p_gkbyg87f2p: FaireProductEntity = {
  token: "p_gkbyg87f2p",
  type: "product",
  name: "XL Brazza Primary Scarf",
  brandToken: "b_3rr38dnsue",
  brandName: "Les Belles Vagabondes",
  imageUrl:
    "https://cdn.faire.com/fastly/6005690bcb37ddf651ca3212b265991be6c0d8935d63ebebeef01f200b52c187.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b4b64ec0e77a8fb1d5b88ab335c5c7ec1c2ee5dc8f60958eee7333a859c3995.jpeg",
  ],
  priceDollars: 46.78,
  description:
    "Our scarves, 100% wool, benefit from exceptional quality thanks to the weaving that provides lightness and a very pleasant softness. \r\nHandmade printing provides deep and subtle colors. \r\n100% wool \r\n100 x 200 cm \r\nDrawn by hand in France \r\nHand printed in India \r\nSold in a pretty fabric gift bag",
  tags: [],
  msrpDollars: 111.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:52.169Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
